import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import elementEnLocale from 'element-ui/lib/locale/lang/en'; // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'; // element-ui lang
import zhCNLocat from 'vxe-table/lib/locale/lang/zh-CN';
import enVXELocat from 'vxe-table/lib/locale/lang/en';

import enLocale from './en';
import zhLocale from './zh';
import dictZhLocale from './systemManage/dict';
import userZhLocale from './systemManage/user';
import menuZhLocale from './systemManage/menu';
import roleZhLocale from './systemManage/role';
import appZhLocale from './systemManage/application';
import accountZhLocale from './systemManage/account';
import applicationCreditList from './purchaseSalesCenter/credit/applicationCredit'; //信用额度申请单列表
import creditList from './purchaseSalesCenter/credit/credit'; //信用额度维护
import creditStatistics from './purchaseSalesCenter/credit/creditStatistics'; //信用额度统计
import upload from './common/upload'; //附件上传
import print from './common/print'; //附件上传
import md from './masterData';
import supplierDeliveryOrderLocale from './wareHouse/stockManage/supplierDeliveryOrder'; //供应商发货指令
import addSupplierDeliveryLocale from './wareHouse/stockManage/addSupplierDelivery'; //创建供应商发货指令
import maintenanceManage from './purchaseSalesCenter/tradingQuota/index'; //交易量额度维护管理页面
import statisticalAnalysis from './purchaseSalesCenter/tradingQuota/statisticalAnalysis'; //交易量额度统计分析
import transportDeliveryOrder from './logisticsCenter/transportDeliveryOrder'; //物流中心-物流出库单
import businessReceipt from './logisticsCenter/businessReceipt'; //物流中心-业务出库单
import purchaseReturn from './purchaseSalesCenter/purchaseReturn'; //采购销售中心-采购退换货
import salesReturnsAndExchange from './purchaseSalesCenter/salesReturnsAndExchange'; //采购销售中心-销售退换货
import salesBill from './purchaseSalesCenter/salesBill'; //销售提单
import departmentBusiness from './departmentBusiness/index';
import departmentBusinessEn from './departmentBusiness/en';
import warehouseContract from './logisticsCenter/warehouseContract'; //物流管理-仓储合同
import transportOrder from './logisticsCenter/transportOrder'; //物流中心-物流运输单
import financeCenter from './financeCenter'; //财务中心
import produceCenter from './produce'; //生产中心
import futuresStrategy from './futuresStrategy/futuresStrategy'; //期货策略

import receivablesZhLocale from './capitalCenter/receivablesManage/index'; //收款管理
import contractAgency from './contract/agencyContract'; // 代理合同
import inventoryTransfer from './wareHouse/inventoryTransfer'; // 代理合同
import settlementBatch from './capitalCenter/settle'; // 结算批次
import sale from './purchaseSalesCenter/sale'; // 销售采购中心
import messageType from './messageCenter/messageType'; //消息类型
import businessOrder from './purchaseSalesCenter/businessOrder'; // 业务订单
import setAccount from './systemManage/setAccount';
import businesDepartment from './capitalPlane/businesDepartment'; //资金计划
import fundFrecast from './capitalPlane/fundFrecast'; //资金计划预报表管理
import logistics from './logisticsCenter/logistics'; //物流入库单
import lossOverflowReport from './wareHouse/lossOverflowReport'; //报损报溢单
import calculation from './purchaseSalesCenter/credit/calculation'; //信用额度统计
import collectBill from './capitalCenter/collectBill'; //应收票据
import queryVoucher from './financeCenter/GeneralAccounting/voucher/query'; //凭证查询
import inventoryQuery from './wareHouse/inventoryQuery'; //库存查询
import costAdjustOrder from './wareHouse/costAdjustOrder'; //库存调整单

import letterOfCredit from './capitalCenter/letterOfCredit'; //信用证
import moneyDraw from './capitalCenter/moneyDraw'; // 资金计息

import aprrovalCenter from './systemManage/aprrovalCenter'; // 审批中心
import mcInboundList from './wareHouse/mcInbound/mcInboundList'; //委托加工入库单列表
import mcInboundEdit from './wareHouse/mcInbound/mcInboundEdit'; //委托加工入库单编辑/新增
//海宁
import HN from '@/common/langHN';
import customerBalance from './purchaseSalesCenter/customerBalance/customerBalance'; //信用额度统计

// 贸易-项目立项
import purchaseProject from './purchaseSalesCenter/project';

// 静态枚举值国际化
import enumsZh from './common/enums';
import enumsEn from './common/enums_en';
Vue.use(VueI18n);

const messages = {
  en_US: {
    ...enLocale,
    ...enVXELocat,
    ...elementEnLocale,
    ...zhCNLocat,
    ...userZhLocale,
    ...dictZhLocale,
    ...menuZhLocale,
    ...roleZhLocale,
    ...appZhLocale,
    ...accountZhLocale,
    ...applicationCreditList,
    ...creditList,
    ...calculation,
    ...upload,
    ...creditStatistics,
    ...supplierDeliveryOrderLocale,
    ...addSupplierDeliveryLocale,
    ...maintenanceManage,
    ...statisticalAnalysis,
    ...transportDeliveryOrder,
    ...transportOrder,
    ...businessReceipt,
    ...purchaseReturn,
    ...salesReturnsAndExchange,
    ...salesBill,
    ...departmentBusinessEn,
    ...receivablesZhLocale,
    ...warehouseContract,
    ...financeCenter,
    ...contractAgency,
    ...inventoryTransfer,
    ...settlementBatch,
    ...sale,
    ...print,
    ...messageType,
    ...businessOrder,
    ...setAccount,
    ...businesDepartment,
    ...fundFrecast,
    ...logistics,
    ...lossOverflowReport,
    ...collectBill,
    ...enumsEn,
    ...queryVoucher,
    ...futuresStrategy,
    ...aprrovalCenter,
    ...inventoryQuery,
    ...costAdjustOrder,
    ...mcInboundList,
    ...mcInboundEdit,
    ...purchaseProject,
  },
  zh_CN: {
    ...zhLocale,
    ...zhCNLocat,
    ...userZhLocale,
    ...dictZhLocale,
    ...menuZhLocale,
    ...roleZhLocale,
    ...appZhLocale,
    ...accountZhLocale,
    ...elementZhLocale,
    ...applicationCreditList,
    ...creditList,
    ...calculation,
    ...upload,
    ...md,
    ...creditStatistics,
    ...supplierDeliveryOrderLocale,
    ...addSupplierDeliveryLocale,
    ...maintenanceManage,
    ...statisticalAnalysis,
    ...transportDeliveryOrder,
    ...transportOrder,
    ...businessReceipt,
    ...purchaseReturn,
    ...salesReturnsAndExchange,
    ...salesBill,
    ...departmentBusiness,
    ...receivablesZhLocale,
    ...warehouseContract,
    ...financeCenter,
    ...contractAgency,
    ...inventoryTransfer,
    ...settlementBatch,
    ...sale,
    ...print,
    ...messageType,
    ...businessOrder,
    ...setAccount,
    ...businesDepartment,
    ...fundFrecast,
    ...logistics,
    ...lossOverflowReport,
    ...collectBill,
    ...enumsZh,
    ...queryVoucher,
    ...letterOfCredit,
    ...moneyDraw,
    ...produceCenter,
    ...futuresStrategy,
    ...aprrovalCenter,
    ...inventoryQuery,
    ...costAdjustOrder,
    ...mcInboundList,
    ...mcInboundEdit,
    ...HN,
    ...customerBalance,
    ...purchaseProject,
  },
};
console.log(messages);
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || 'zh_CN',
  // set locale messages
  messages,
  silentTranslationWarn: true,
});

export default i18n;
